import { BASE_FONT_FAMILY, FONT_WEIGHTS } from './fonts.constants';
// line-height 계산 함수
function getLineHeight(size) {
    if (size >= 40) {
        return size + 8;
    }
    if (size >= 20) {
        return size + 8;
    }
    return size + 6;
}
// 폰트 맵 생성
export const fonts = {};
Object.entries(FONT_WEIGHTS).forEach(([weight, sizes]) => {
    sizes.forEach((size) => {
        const key = `samsung-${weight}-${size}`;
        fonts[key] = {
            weight: parseInt(weight),
            size: `${size / 10}rem`,
            height: `${getLineHeight(size) / 10}rem`,
            family: BASE_FONT_FAMILY,
        };
    });
});
export function getFontStyle(style) {
    if (!fonts[style]) {
        throw new Error(`Font style \`${style}\` not found in fonts.`);
    }
    const fontStyle = fonts[style];
    return `
    font-family: ${fontStyle.family};
    font-weight: ${fontStyle.weight};
    font-size: ${fontStyle.size};
    line-height: ${fontStyle.height};
  `;
}
//# sourceMappingURL=fonts.js.map